import { createContext, useContext } from "react";

export const LangContext = createContext<string>(window.navigator.language)

export const useLang = () => useContext(LangContext)
